import mixpanel from 'mixpanel-browser';

function validate(context) {
  if (!(context instanceof Object)) {
    throw new Error('Cannot validate without a context object');
  }
  if (typeof context.eventName !== 'string') {
    throw new Error('Cannot send event without event name');
  }
  if (!(context.eventProperties instanceof Object)) {
    throw new Error('Cannot send event without event properties');
  }
}

export default class MixpanelTracker {
  setEventName(eventName) {
    this.eventName = eventName;
  }

  setEventProperties(eventProperty) {
    this.eventProperties = eventProperty;
  }

  sendEvent(sendToCrossProject = false) {
    if (mixpanel.has_opted_out_tracking()) {
      return;
    }
    validate(this);

    if (sendToCrossProject === true) {
      mixpanel.crossProduct.track(this.eventName, this.eventProperties);
    } else {
      mixpanel.track(this.eventName, this.eventProperties);
    }
  }
}



// WEBPACK FOOTER //
// ./src/Telemetry/Mixpanel/mixpanelTracker.js